<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// 引入公用的css
import '@/assets/css/base.css'

export default {
  name: 'App'
}
</script>
<style>

</style>
